import styles from './PageComponents.scss';
import classnames from 'classnames';

export const PageTitle = (props) => (
    <h1 {...props} className={classnames(styles.title, props.className)} data-cy="PageComponents-PageTitle">
        {props.children}
    </h1>
);

export const PageDescription = (props) => (
    <p className={classnames(props.className, styles.description)} data-cy="PageComponents-PageDescription">
        {props.children}
    </p>
);
